import React, { Component, Fragment } from 'react'
import { Button, Card, Col, Divider, Row, Table } from 'antd'
import EditModal from '../../People/Member/Modal/Profile'

class Profile extends Component {
  columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (text, record, index) => (
        <a
          onClick={() =>
            this.setState({
              repVisible: true,
              rep: { _key: record.repID },
            })
          }>
          {text}
        </a>
      ),
    },
    {
      title: 'Position',
      dataIndex: 'position',
    },
    { title: 'Email', dataIndex: 'email' },
    { title: 'Phone', dataIndex: 'phone' },
  ]
  state = {
    visible: false,
    fetching: true,
    repVisible: false,
    rep: {},
  }

  render() {
    const { member, repsList, loading } = this.props
    return loading ? (
      <Card loading={loading} />
    ) : (
      <Fragment>
        <Row>
          <Col span={3} style={{ fontWeight: 'bold' }}>
            Full Name:
          </Col>
          <Col span={4} style={{ textAlign: 'left' }}>
            {member.fn}
          </Col>
          <Col span={3} style={{ fontWeight: 'bold' }}>
            Registration Date:
          </Col>
          <Col span={4}>{member.registrationDate}</Col>
          <Col span={3} style={{ float: 'right' }}>
            <Button
              onClick={() =>
                this.setState({
                  visible: true,
                })
              }
              type="dashed"
              icon="user-add">
              Update Profile
            </Button>
          </Col>
        </Row>
        <Row
          style={{
            paddingBottom: '10px',
            borderBottom: '1px solid rgb(217,217,217)',
          }}>
          <Col span={3} style={{ fontWeight: 'bold' }}>
            Trading Name:
          </Col>
          <Col span={4} style={{ textAlign: 'left' }}>
            {member.tradingName}
          </Col>
          <Col span={3} style={{ fontWeight: 'bold' }}>
            Country:
          </Col>
          <Col span={4}>{member.cob}</Col>

          <EditModal
            visible={this.state.visible}
            handleCancel={() =>
              this.setState({
                visible: false,
              })
            }
            member={member}
          />
          <EditModal
            visible={this.state.repVisible}
            handleCancel={() =>
              this.setState({
                repVisible: false,
              })
            }
            member={this.state.rep}
          />
        </Row>
        <Row style={{ paddingTop: 10 }}>
          <Col span={24}>{member.profile}</Col>
        </Row>
        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <Col span={12}>
            <h3 style={{ color: 'rgb(235,113,103' }}>{'Representatives'.toUpperCase()}</h3>
          </Col>
        </Row>
        <Row>
          <Table columns={this.columns} dataSource={repsList} size="small" />
        </Row>
        <Divider />
      </Fragment>
    )
  }
}

export default Profile
